/* eslint-disable consistent-return */
import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
// import ResendMailGochiButton from '../atoms/ResendMailGochiButton';
// import ResendGochiButton from '../atoms/ResendGochiButton';
import ResendMailTextButton from '../atoms/ResendMailTextButton';
import ResendGochiTextButton from '../atoms/ResendGochiTextButton';
import RejectGochiTextButton from '../atoms/RejectGochiTextButton';

const styles = {};

const enhance = compose(pure);

const ShopTableBody = enhance(
  ({
    stripeChargeEvents,
    emptyRows,
    page,
    rowsPerPage,
    resendMailAction,
    resendGochiAction,
    rejectGochiAction
    // confirmOpenAction,
    // roles
  }) => {
    return (
      <TableBody>
        {stripeChargeEvents
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(result => {
            const paramsSendGochi = {
              successUrl: result.successUrl
            };
            const paramsSendMail = {
              chargeId: result.chargeId
            };
            const paramsRejectGochi = {
              chargeId: result.chargeId
            };
            return (
              <TableRow key={result.id}>
                <TableCell>{result.id}</TableCell>
                <TableCell>{result.chargeId}</TableCell>
                <TableCell>{result.paymentIntent}</TableCell>
                <TableCell>{result.customerEmail}</TableCell>
                <TableCell>{result.amount}</TableCell>
                <TableCell>{result.balanceTransaction}</TableCell>
                <TableCell>
                  {(() => {
                    if (result.checkStatus === 0) return 'NONE';
                    if (result.checkStatus === 1) return 'OK';
                    if (result.checkStatus === 2) return 'NG';
                    if (result.checkStatus === 3) return 'REJECT';
                    if (result.checkStatus === 4) return 'DONE';
                  })()}
                </TableCell>
                {/* <TableCell>{result.successUrl}</TableCell> */}
                <TableCell>{result.createdAt}</TableCell>
                <TableCell>{result.updatedAt}</TableCell>
                <TableCell>
                  {result.resendGochi && (
                    <ResendMailTextButton
                      params={paramsSendMail}
                      onClickAction={resendMailAction}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {result.successUrl && !result.resendGochi && (
                    <ResendGochiTextButton
                      params={paramsSendGochi}
                      onClickAction={resendGochiAction}
                    />
                  )}
                </TableCell>
                <TableCell>
                  <RejectGochiTextButton
                    params={paramsRejectGochi}
                    onClickAction={rejectGochiAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={9} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
